import React from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Box, CircularProgress } from '@mui/material'
import dayjs from 'dayjs'

const formatDate = (value) => (value ? dayjs(value).format('DD/MM/YYYY') : '')

const EsitoCell = ({ value }) => {
  const isPresente = value === 'PRESENTE'
  const dotColor = isPresente ? '#d32f2f' : '#2e7d32' // rosso se presente, verde se non presente

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: dotColor,
          flexShrink: 0,
        }}
      />
      <span>{value}</span>
    </Box>
  )
}

const NotizieDaVerificareCell = ({ value }) => {
  const numero = Number(value) || 0

  if (numero <= 0) {
    return <span>-</span>
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <Box
        sx={{
          backgroundColor: '#fdecea',
          border: '1px solid #f5b5ac',
          color: '#c62828',
          borderRadius: '16px',
          px: 1.25,
          py: 0.25,
          fontSize: '0.8125rem',
          fontWeight: 500,
          whiteSpace: 'nowrap',
        }}
      >
        {numero} {numero === 1 ? 'nuova' : 'nuove'}
      </Box>
    </Box>
  )
}

const columns = [
  { field: 'cognome', headerName: 'Cognome', flex: 1, minWidth: 120 },
  { field: 'nome', headerName: 'Nome', flex: 1, minWidth: 120 },
  { field: 'codiceFiscale', headerName: 'Codice Fiscale', flex: 1, minWidth: 140 },
  {
    field: 'dataScreening',
    headerName: 'Data screening',
    flex: 1,
    minWidth: 130,
    valueFormatter: (params) => formatDate(params.value),
  },
  {
    field: 'esito',
    headerName: 'Esito',
    flex: 1,
    minWidth: 120,
    renderCell: (params) => <EsitoCell value={params.value} />,
  },
  { field: 'ndgClienteCollegato', headerName: 'NDG Cliente collegato', flex: 1, minWidth: 160 },
  { field: 'saleDiRiferimento', headerName: 'Sale di riferimento', flex: 1, minWidth: 140 },
  { field: 'pivaClienteCollegato', headerName: 'PIVA Cliente collegato', flex: 1, minWidth: 160 },
  {
    field: 'notizieDaVerificare',
    headerName: 'N. notizie nuove',
    flex: 1,
    minWidth: 150,
    renderCell: (params) => <NotizieDaVerificareCell value={params.value} />,
  },
]

const ResultsTableSoggettoTerzo = ({ rows, isLoading, onRowClick }) => {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <DataGrid
      rows={rows || []}
      columns={columns}
      getRowId={(row, index) => row?.id ?? `fallback-${index}`}
      onRowClick={onRowClick}
      disableSelectionOnClick
      pageSize={25}
      rowsPerPageOptions={[10, 25, 50, 100]}
      sx={{ height: '100%', width: '100%' }}
    />
  )
}

export default ResultsTableSoggettoTerzo